import React, { Component, Fragment } from "react";
import "./PurchaseOrderDetail.css";
import { Button } from "react-bootstrap";
import Header from "./Header";
import PODTable from "./PODTable";
import StatusModal from "../common/StatusModal";
import {
  getPurchaseOrderDetail,
  updateHeaderDetail,
  addItem
} from "../../actions";
import Spinner from "../common/Spinner";
import Sanckbar from "../common/Sanckbar";
import AddItemForm from "./AddItemForm";
import CustomButton from "../common/CustomButton";

import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';

class PurchaseOrderDetail extends Component {
  state = {
    // headerUpdate: { update: false },
    isReceived:
      this.props.location.state.purchaseOrder.status === "R" ? true : false,
    notificationMsg: "",
    isSaveEnabled: false,
    isSuffixSelectionActive: true,
    newStatus: false,
    data:
      this.props.location && this.props.location.state
        ? this.props.location.state.purchaseOrder
        : "",
    suffixes:
      this.props.location && this.props.location.state
        ? this.props.location.state.sufixes
        : "",
    itemLookup: "",
    numberOfRows: 15,
    currentPage: 1,
    allowAddItem: this.props.location.state.isAddItemAllowed,
    todosPerPage: 15,
    pageNumbers: [],
    currentPagination: 1,
    paginationLimit: 7,
  };
  constructor(props) {
    super(props);
    this.changes = [];
    // eslint-disable-next-line
    this.lastPage = "";
    this.snackbarTimer = "";
  }
  handleOnClickSuffix = suffix => {
    if (Object.keys(this.changes).length < 1 || this.state.headerChanges) {
      this.setState({ isSuffixSelectionActive: true });
    } else {
      this.setState({ isSuffixSelectionActive: false });
      this.setState({ isModalButtonActive: true });
      this.setState({
        button1Action: e => this.discardChanges(),
        button2Action: e => this.saveChanges()
      });
      this.handeOpenModal(
        "choice",
        "Input...",
        "There are unsaved changes. Please select one of the following actions.",
        "format_list_bulleted",
        "Discard",
        "Save"
      );
    }
  };

  changeSuffix = suffix => {
    // this.setNotification("");
    // this.handleIsSearching(true);
    this.setState({ filteredRows: false });
    this.setState({ data: suffix });
    this.getItemRows(suffix);

    // this.state.data.poh_suffix
  };

  handeOpenModal = (param, param2, param3, param4, param5, param6) => {
    this.setState({ modalTitle: param2 });
    this.setState({ modalMsg: param3 });
    this.setState({ modalIcon: param4 });
    this.setState({ modalButtonText: param5 });
    this.setState({ modalButtonText2: param6 });
    this.state.modalOpen
      ? this.setState({ modalOpen: false })
      : this.setState({ modalOpen: true });
    this.setState({ action: param });
    if (param === "success" || param === "fail") {
      this.setState({ onlyClose: true });
    } else {
      this.setState({ onlyClose: false });
    }
  };

  closeModal = e => {
    this.setState({ modalOpen: false });
    
  };

  onChangeItemLookup = value => {
    var filteredQuery = 0;

    if (value.length > 9) {
      this.setWarningMessage("Must Be 1-9 Characters");
    } else if (value.match(/[^\d.-]/g, "")) {
      this.setWarningMessage("Must Be Numeric");
    } else {
      this.setWarningMessage(false);
    }
    filteredQuery = value.slice(0, 9).replace(/[^\d.-]/g, "");
    // this.props.onChange(filteredQuery);

    if (Object.keys(this.changes).length < 1 || this.state.headerChanges) {
      this.setState({ itemLookup: filteredQuery });
    } else {
      this.setState({ isModalButtonActive: true });
      this.setState({
        button1Action: e => this.discardChanges(filteredQuery),
        button2Action: e => this.saveChanges()
      });
      this.handeOpenModal(
        "choice",
        "Input...",
        "There are unsaved changes. Please select one of the following actions.",
        "format_list_bulleted",
        "Discard",
        "Save"
      );
    }
    if (Object.keys(this.changes).length < 1) {
      this.setState({
        filteredRows: this.state.rows.filter(
          item =>
            item.itemNumber
              .toString()
              .toLowerCase()
              .indexOf(filteredQuery.toString().toLowerCase()) > -1
        )
      });
    }
    this.setState({ currentPage: 1 });
  };

  saveChanges = action => {
    var changesArray = [];
    this.setTransitioMessage(<Spinner msg="Saving..." />);
    this.setState({ isSaving: true });
    for (let o = 0; o < Object.keys(this.changes).length; o++) {
      changesArray.push({
        poNumber: this.state.data.poNumber,
        suffix: this.state.suffix,
        availFlag: this.changes[Object.keys(this.changes)[o]].availFlag,
        cancelFlag: this.changes[Object.keys(this.changes)[o]].cancelFlag,
        fbuyFlag: this.changes[Object.keys(this.changes)[o]].fbuyFlag,
        invCategory: this.changes[Object.keys(this.changes)[o]].invCategory,
        qtyOrdered: this.changes[Object.keys(this.changes)[o]].qtyOrdered,
        itemNumber: parseInt(Object.keys(this.changes)[o], 10)
        // poh_po_note: "note"
      });
    }
    this.setState({ filteredRows: false });

    var uId = sessionStorage.getItem("uId");

    var obj = {
      audit: {
        userId: uId
      },
      poHeader: this.state.headerUpdate,
      poHeaderDetails: changesArray
    };

    updateHeaderDetail(obj).then(res => {
      if (res.data.success) {
        this.changes = {};
        this.setState({ headerNewData: this.state.headerUpdate });
        this.setTransitioMessage();
        this.setState({ isSaving: false });
        this.changeSuffix(this.state.data);
        setTimeout(() => {
          this.setSuccessMessage("Changes saved!");
          if (action === "close") {
            setTimeout(() => {
              this.close();
            }, 1000);
          }
        }, 1000);
      } else {
        this.setErrorMessage(res.data.messages[0].text);
      }
    }).catch(err => {
      const code = String(err).split('code')[1];
      if(code == 401) {
        this.setErrorMessage(`Error code ${code}, token expired, please login again.`);
        setTimeout(() => {
          this.setErrorMessage();
        }, 3000);
      } else {
          this.setErrorMessage(`Error code ${code}, cannot complete the action now, please try again later.`);
          setTimeout(() => {
            this.setErrorMessage();
          }, 3000);
      }
    });

    this.closeModal();
    this.setState({ itemLookup: "" });
    this.setState({ isSaveEnabled: false });
    this.setState({ isSuffixSelectionActive: true });
    this.changes = {};
  };
  discardChanges = (filteredQuery, action) => {
    this.setState({ headerNewData: false });
    this.changeSuffix(this.state.data);
    this.changes = {};
    this.closeModal();
    this.setState({ itemLookup: filteredQuery });
    this.setState({ isSaveEnabled: false });
    this.setState({ isSuffixSelectionActive: true });
    this.setWarningMessage("Changes discarded...");
    setTimeout(() => {
      this.setWarningMessage();
      // eslint-disable-next-line
      action === "close" ? this.close() : null;
    }, 2000);
  };
  setErrorMessage = msg => {
    this.setNotification(msg, "red", "cancel");
  };
  setWarningMessage = msg => {
    this.setNotification(msg, "orange", "warning", 3000);
  };
  setSuccessMessage = msg => {
    this.setNotification(msg, "#47fb47", "check", 3000);
  };
  setTransitioMessage = msg => {
    this.setNotification(msg, null, null);
  };
  setNotification = (text, color, icon, timeout) => {
    clearTimeout(this.snackbarTimer);

    if (text) {
      this.setState({ notificationMsg: { text, color, icon } });
      this.setState({ isNotificationOpened: true });
    } else {
      this.setState({ isNotificationOpened: false });
    }
    if (timeout) {
      this.snackbarTimer = setTimeout(() => {
        this.setState({ isNotificationOpened: false });
      }, timeout);
    }
  };
  getRowInfo = (newData, prevData) => {
    // this.setNotification("");
    newData.parentElement.firstChild.checked = true;
    const newDataObj = {
      availFlag: newData.children[5].firstChild.firstChild.checked
        ? "Y"
        : "N" /** */,
      cancelFlag: newData.children[0].firstChild.firstChild.checked ? "Y" : " ",
      fbuyFlag: newData.children[4].firstChild.firstChild.checked ? "Y" : "N",
      invCategory: newData.children[8].firstChild.value,
      qtyOrdered: parseInt(newData.children[6].children[1].value, 10)
    };
    const prevDataObj = {
      availFlag: prevData.availFlag,
      cancelFlag: prevData.cancelFlag,
      fbuyFlag: prevData.fbuyFlag,
      invCategory: prevData.invCategory,
      qtyOrdered: prevData.qtyOrdered
    };
    if (JSON.stringify(prevDataObj) !== JSON.stringify(newDataObj)) {
      this.changes[prevData.itemNumber] = newDataObj;
    } else {
      delete this.changes[prevData.itemNumber];
    }
    this.isSaveEnabled();
  };
  isSaveEnabled = () => {
    if (Object.keys(this.changes).length > 0 || this.state.headerChanges) {
      this.setState({ isSaveEnabled: true });
    } else {
      this.setState({ isSaveEnabled: false });
    }
  };
  activateCloseButton = bool => {
    this.setState({ isCloseButtonActive: bool });
  };
  renderPaginator = () => {
    var numberOfPages =
      Math.ceil(
        (this.state.filteredRows
          ? this.state.filteredRows.length
          : this.state.rows.length) / this.state.numberOfRows
      ) + 1;
    this.lastPage = numberOfPages - 1;
    var pages = [];
    for (let i = 1; i < numberOfPages; i++) {
      pages.push(i);
    }
    return pages.map(pag => {
      return (
        <Fragment key={pag}>
          <input
            className="page-selector"
            type="radio"
            name="paginator"
            id={`page-indicator-${pag}`}
            onChange={e => this.setState({ currentPage: pag })}
            checked={pag === this.state.currentPage}
          />
          <label className="page-indicator" htmlFor={`page-indicator-${pag}`}>
            {pag}
          </label>
        </Fragment>
      );
    });
  };

  getItemRows = suffix => {
    this.setTransitioMessage(<Spinner msg="Loading..." />);

    this.setState(
      suffix ? { suffix: suffix.suffix } : { suffix: this.state.data.suffix }
    );
    // eslint-disable-next-line
    var arr = [];
    getPurchaseOrderDetail(
      this.state.data.poNumber,
      suffix ? suffix.suffix : this.state.data.suffix
    ).then(res => {
      var poItems = [];
      res.data.poItems.map(item => {
        poItems.push(item.itemNumber);
        return null;
      });
      this.setState({ poItems });

      arr = res.data.details;
      this.setTransitioMessage();
      
      let pages = [];
      for (let i = 1; i <= Math.ceil( res.data.details.length / this.state.todosPerPage); i++) {
          pages.push(i);
      } 


      this.setState({ rows: res.data.details,  pageNumbers: pages });
      if (this.state.itemAdded) {
        this.onChangeItemLookup(this.state.itemAdded + "");
        this.setState({ itemAdded: false });
      } else {
        this.onChangeItemLookup("");
      }
      if (!res.data.success) {
        this.setErrorMessage(res.data.messages[0].text);
      }
    }).catch(err => {
      const code = String(err).split('code')[1];
      if(code == 401) {
        this.setErrorMessage(`Error code ${code}, token expired, please login again.`);
        setTimeout(() => {
          this.setErrorMessage();
        }, 3000);
      } else {
          this.setErrorMessage(`Error code ${code}, cannot complete the action now, please try again later.`);
          setTimeout(() => {
            this.setErrorMessage();
          }, 3000);
      }
    });
  };
  componentDidMount() {
    this.getItemRows();
    
  }
  close = () => {
    this.props.history.push({
      pathname: "/poheader",
      state: {
        poh_ponumber: this.state.data.poNumber,
        sufixes: this.props.data
      }
    });
  };
  handleClose = () => {
    if (Object.keys(this.changes).length < 1 || this.state.headerChanges) {
      this.close();
    } else {
      this.setState({ isModalButtonActive: true });
      this.setState({
        button1Action: e => this.discardChanges(null, "close"),
        button2Action: e => this.saveChanges("close")
      });
      this.handeOpenModal(
        "choice",
        "Input...",
        "There are unsaved changes. Please select one of the following actions.",
        "format_list_bulleted",
        "Discard",
        "Save"
      );
    }
  };
  selectNumberOfRows = e => {
    this.setState({ numberOfRows: null });
    this.setState({ numberOfRows: e.target.value });
  };
  handleAddItem = () => {
    this.setState({
      button1Action: e => this.closeModal(),
      button2Action: e =>
        this.state.isAddItemActive
          ? this.addITem(this.state.itemToSubmit)
          : this.setErrorMessage("Please fill all fields properly")
    });
    this.handeOpenModal(
      "choice",
      "Input...",
      <AddItemForm
        rows={this.state.rows}
        setErrorMessage={this.setErrorMessage}
        areAllFieldsFilled={this.areAllFieldsFilled}
        validateDuplicated={this.checkDuplicatedItem}
      />,
      "format_list_bulleted",
      false,
      "Add Item"
    );
    window.test3 = true;
  };
  checkDuplicatedItem = value => {
    value = parseInt(value, 10);
    return this.state.poItems.includes(value);
  };

  areAllFieldsFilled = (isAddItemActive, object) => {
    this.setState({ isAddItemActive });
    this.setState({ isModalButtonActive: isAddItemActive });

    this.setState({ itemToSubmit: object });
  };

  
  // poNumber, suffix, whse
  addITem = item => {
    this.setTransitioMessage("Loading...");

    item.poNumber = this.state.data.poNumber;
    item.suffix = this.state.data.suffix;
    item.whse = this.state.data.whse;
    item.itemNumber = parseInt(item.itemNumber, 10);
    item.fbuyFlag === true ? (item.fbuyFlag = "Y") : (item.fbuyFlag = "N");
    item.availFlag === true ? (item.availFlag = "Y") : (item.availFlag = "N");

    var uId = sessionStorage.getItem("uId");

    var obj = {
      audit: {
        userId: uId
      },
      poHeaderDetails: [item]
    };

    addItem(obj).then(res => {
      if (res.data.success) {
        this.changes = {};
        this.setTransitioMessage();
        this.setState({ isSaving: false });
        this.changeSuffix(this.state.data);
        setTimeout(() => {
          this.setSuccessMessage("Changes saved!");
        }, 10);
        this.setState({ itemAdded: item.itemNumber });
        this.closeModal();
      } else {
        this.setTransitioMessage();
        setTimeout(() => {
          this.setErrorMessage("Invalid item number");
        }, 10);
        this.onChangeItemLookup("");
        setTimeout(() => {
          this.setErrorMessage();
        }, 2000);
      }
    }).catch(err => {
      const code = String(err).split('code')[1];
      if(code == 401) {
        this.setErrorMessage(`Error code ${code}, token expired, please login again.`);
        setTimeout(() => {
          this.setErrorMessage();
        }, 3000);
      } else {
          this.setErrorMessage(`Error code ${code}, cannot complete the action now, please try again later.`);
          setTimeout(() => {
            this.setErrorMessage();
          }, 3000);
      }
    });
  };
  headerUpdate = (x, activateSaveChanges) => {
    if (
      JSON.stringify(this.state.headerUpdate) !== JSON.stringify(x.headerUpdate)
    ) {
      this.setState(x);
      this.setState({ headerChanges: activateSaveChanges });
      setTimeout(() => {
        this.isSaveEnabled();
      }, 10);
    }
  };

  componentDidUpdate() {
    if (this.state.data.status === "R" ) {
      if (this.state.isReceived === false) {
        this.setState({ isReceived: true });
      }
    } else {
      if (this.state.isReceived === true) {
        this.setState({ isReceived: false });
      }
    }
  }

  handleClickPagination = (number) => {
    if(this.state.pageNumbers.length > 0) {
        if(typeof(number) === 'number') {
            const pageNumber = this.state.currentPagination + number;
            const limitPagination = Math.ceil(this.state.pageNumbers.length / this.state.paginationLimit);
            if(pageNumber > 0 && pageNumber <= limitPagination) {
                this.setState({
                    currentPagination: pageNumber
                });
            }
        } else {
            if(number === 'first') {
                this.setState({
                    currentPagination: 1
                });
            } else {
                const limitPagination = Math.ceil(this.state.pageNumbers.length / this.state.paginationLimit);
                this.setState({
                    currentPagination: limitPagination
                });

            }
        }   
    }
}

handleClick = (number) => {
  const pageNumber = number;
  this.setState({
    currentPage: pageNumber
  });
}
  render() {

       //Pagination logic

       const { currentPagination, paginationLimit } = this.state;

       const indexOfLastPagination = currentPagination * paginationLimit;
       const indexOfFirstPagination = indexOfLastPagination - paginationLimit;
       const currentPaginationList = this.state.pageNumbers.slice(indexOfFirstPagination, indexOfLastPagination);

       
    return (
      <div className="container-fluid app-container">
        <div className="row justify-content-center">
          <div>
            <h3 className="page-title">
              Purchase Order Item Detail Maintenance
            </h3>
          </div>
        </div>
        <Header
          headerUpdate={this.headerUpdate}
          headerNewData={this.state.headerNewData}
          data={this.state.data}
          isSuffixSelectionActive={this.state.isSuffixSelectionActive}
          suffixes={this.state.suffixes}
          changeSuffix={this.changeSuffix}
          clickSuffix={this.handleOnClickSuffix}
          itemLookup={this.state.itemLookup}
          onChange={this.onChangeItemLookup}
          activateCloseButton={this.activateCloseButton}
          // newStatus={this.state.newStatus}
          openModal={this.handeOpenModal}
          closeModal={this.closeModal}
          sendErrorMsg={this.setWarningMessage}
        />
        {this.state.filteredRows ? (
          <PODTable
            rows={this.state.filteredRows}
            changes={this.changes}
            getRowInfo={this.getRowInfo}
            numberOfRows={this.state.numberOfRows}
            currentPage={this.state.currentPage}
            readOnly={this.state.isReceived}
          />
        ) : null}
        <div className="button-bar">
          {this.state.filteredRows ? (
            <div >
              <Pagination aria-label="Table navigation" className="pagination2">
                    <PaginationItem>
                        <PaginationLink first  onClick={e => {this.handleClickPagination('first')}}/>
                    </PaginationItem>
                    <PaginationItem>
                        <PaginationLink previous onClick={e => {this.handleClickPagination(-1)}}/>
                    </PaginationItem>
                    {currentPaginationList.map((data, key) => {
                        return (
                            <PaginationItem key={key}>
                                <PaginationLink onClick={e => this.handleClick(data)}>
                                    {data}
                                </PaginationLink>
                            </PaginationItem>
                        )
                    })
                    }
                    <PaginationItem>
                        <PaginationLink  next onClick={e => {this.handleClickPagination(1)}}/>
                    </PaginationItem>
                    <PaginationItem>
                        <PaginationLink last onClick={e => {this.handleClickPagination('last')}}/>
                    </PaginationItem>
                </Pagination>  
            </div>
          ) : null}

          <div className="buttons">
            <CustomButton
              bsStyle="warning"
              className="btn-sm"
              onClick={this.handleAddItem}
              isDisabled={
                this.state.isReceived
                  ? true
                  : typeof this.state.allowAddItem === "string"
                  ? true
                  : false
              }
              msg={
                this.state.isReceived
                  ? "Can not update received POs"
                  : typeof this.state.allowAddItem === "string"
                  ? this.state.allowAddItem
                  : ""
              }
              value="Add Item"
            />

            <Button
              bsStyle="warning"
              className="btn-sm"
              onClick={e => this.handleClose()}
            >
              Back
            </Button>
            <CustomButton
              bsStyle="warning"
              className="btn-sm"
              isDisabled={!this.state.isSaveEnabled || this.state.isReceived}
              onClick={e => this.saveChanges()}
              value="Save"
              msg={this.state.isReceived ? "Can not update received POs" : ""}
            >
              Save
            </CustomButton>
          </div>
        </div>

        <StatusModal
          modal={this.state.modalOpen === true ? "opened" : "closed"}
          action={this.state.action}
          handleOpenClose={e => this.closeModal(e)}
          buttonActions={{
            button1: this.state.button1Action,
            button2: this.state.button2Action
          }}
          hasOnlyClose={this.state.onlyClose}
          title={this.state.modalTitle}
          msg={this.state.modalMsg}
          icon={this.state.modalIcon}
          active={this.state.isModalButtonActive}
          buttonText={this.state.modalButtonText}
          buttonText2={this.state.modalButtonText2}
        />

        <Sanckbar
          mounted={this.state.isNotificationOpened}
          msg={{
            text: this.state.notificationMsg.text,
            color: this.state.notificationMsg.color,
            icon: this.state.notificationMsg.icon
          }}
          close={this.setNotification}
        />
      </div>
    );
  }
}

export default PurchaseOrderDetail;
